// @ts-ignore
import { useEffect } from 'react';

import { css } from '@compiled/react';
import { FormattedMessage } from 'react-intl';

import { useAnalyticsEvents } from '@atlaskit/analytics-next';

import { ufoEventRedirectToProduct } from '@/components/signup/utils/ufo-events';
import { DEFAULT_VALUES } from '@/libraries/web-framework/src/localization/values';
import MainContainer from '@/templates/ondemand/signup/confirmation/confirmation-page/src/components/main-container/main-container';

import { useAnalyticsClient } from '../../../../../../../../analytics/wac-analytics/analytics-client';
import { MessageContainerProps } from '../../components/styles';
import ProgressBar from '../../sections/progress-bar';

const MessageContainer = css(MessageContainerProps);

const image =
	'https://wac-cdn.atlassian.com/dam/jcr:504d3972-1e50-4ff8-8ba8-66520e0ade03/inbox.svg';

const TimeoutView = () => {
	const analyticsClient = useAnalyticsClient();
	const { createAnalyticsEvent } = useAnalyticsEvents();

	useEffect(() => {
		// Confirming analyticsClient is initialized before firing event
		analyticsClient &&
			createAnalyticsEvent({
				eventName: 'timeoutPageViewed',
				eventComponent: 'timeoutPage',
				event: 'viewed',
			}).fire('signup');
	}, [analyticsClient, createAnalyticsEvent]);

	// SLO "bad event" for redirect into product
	useEffect(() => {
		ufoEventRedirectToProduct.failure({
			customData: {
				reactComponent: 'TimeoutView',
				analyticsEvent: 'timedOut',
				redirectFrom: 'confirmationPage',
			},
		});
	}, []);

	return (
		<MainContainer>
			{/* eslint-disable-next-line no-restricted-syntax */}
			<img src={image} height="300px" alt={''} />
			<ProgressBar />
			<div css={MessageContainer}>
				<FormattedMessage
					id={'confirmation.TimeoutView.text'}
					defaultMessage={
						"<p>This is taking longer than expected.{br}\nDon't worry, we'll send you an email when your site is ready.</p>"
					}
					values={DEFAULT_VALUES}
				/>
			</div>
		</MainContainer>
	);
};

export default TimeoutView;
